import React from 'react';

export function Footer() {
  return (
    <footer className="bg-white border-t mt-8 p-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-3">
          <img
            src="/logo.png"
            alt="GoodPlace"
            className="h-8 w-auto"
          />
          <span className="text-xl font-bold text-gray-800">GoodPlace</span>
          <span className="text-lg text-gray-500">MATCH</span>
        </div>

        <p className="text-gray-600 text-sm max-w-md mx-auto mb-4">
          Dritte Orte schaffen eine Gegenwartsutopie – Orte, an denen wir einfach sein können.
        </p>

        {/* GoodWork Ökosystem */}
        <div className="pt-4 border-t border-gray-100">
          <p className="text-xs text-gray-400 mb-2">Teil des GoodWork Ökosystems</p>
          <div className="flex justify-center items-center gap-4 text-xs">
            <a
              href="https://goodwork-crafting.web.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-500 hover:text-indigo-700 hover:underline transition-colors"
            >
              GoodWork Crafting
            </a>
            <span className="text-gray-300">•</span>
            <span className="text-gray-500 font-medium">GoodPlace Match</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
